<div class="sidebar">
    <div class="sidebar__brand">
        <a routerLink="/" class="sidebar__logo-link" (click)="navigate.emit()">
            <img class="sidebar__logo" [src]="branding.logo" alt="" />
            <span class="sr-only">{{ 'common.title' | translate }}</span>
        </a>
        <div class="workspace" [class.workspace--controlling]="controlling">
            <div class="workspace__text">
                @if (branding.organizationName) {
                    <span class="workspace__name">{{ branding.organizationName }}</span>
                }
                @if (controlling) {
                    <span class="workspace__app workspace__control" role="status">
                        <span class="material-symbols-outlined icon-sm" aria-hidden="true">supervisor_account</span>
                        {{ 'menu.shell.controlMode' | translate }}
                    </span>
                } @else {
                    <span class="workspace__app">{{ 'common.title' | translate }}</span>
                }
            </div>
            @if (branding.canSwitchOrganization) {
                <a
                    class="workspace__switch"
                    routerLink="/app/change-organization"
                    [pTooltip]="'components.changeOrg.menu' | translate"
                    [attr.aria-label]="'components.changeOrg.menu' | translate"
                    (click)="navigate.emit()">
                    <span class="material-symbols-outlined icon-md" aria-hidden="true">sync_alt</span>
                </a>
            }
            @if (controlling) {
                <button type="button" class="workspace__exit" (click)="stopControlling.emit()">
                    <span class="material-symbols-outlined icon-sm" aria-hidden="true">logout</span>
                    {{ 'menu.shell.stopControl' | translate }}
                </button>
            }
        </div>
    </div>

    <nav class="sidebar__nav" [attr.aria-label]="'menu.shell.navigation' | translate">
        @if (loading) {
            <div class="sidebar__loading">
                @for (row of loadingRows; track row) {
                    <p-skeleton height="2.25rem" />
                }
            </div>
        } @else {
            @for (section of navigation.sections; track $index; let first = $first) {
                @if (!first) {
                    <hr class="sidebar__divider" />
                }
                <app-nav-list [items]="section" [currentUrl]="currentUrl" (selected)="navigate.emit()" />
            }
        }
    </nav>

    <div class="sidebar__footer">
        @if (freeTrialDaysLeft !== null) {
            <app-free-trial-card [daysLeft]="freeTrialDaysLeft" (contact)="contactSales.emit()" />
        }
        <div class="sidebar__account">
            <app-account-menu
                [name]="account.name"
                [email]="account.email"
                [entries]="navigation.account"
                [languages]="languages"
                [currentLanguage]="currentLanguage"
                (selected)="navigate.emit()"
                (languageChange)="languageChange.emit($event)"
                (logout)="logout.emit()" />
        </div>
        @if (showPoweredBy) {
            <a class="sidebar__powered" href="https://www.d-carbonize.eu" target="_blank" rel="noopener">
                <img src="assets/images/logo/logo-provider.webp" alt="D-Carbonize" />
            </a>
        }
    </div>
</div>
